export const knownSeparators = [":", "/", "."];

export const defaultDateSeparator = "/";

export const defaultTimeSeparator = ":";